import { createContext } from "react";

const publicContex = createContext ({
    count: undefined,
});

export default publicContex ;
